import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed ml-6 right-5 top-[4.5rem] h-[10rem] w-[31rem] px-4 py-8 dark:text-white dark:bg-gray-500 bg-white z-[999]",
  "data-test": "container"
}
const _hoisted_2 = { class: "flex justify-between mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChTypography = _resolveComponent("ChTypography")!
  const _component_ch_icon = _resolveComponent("ch-icon")!

  return (_ctx.showToast)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ChTypography, {
          variant: "Untitled14Regular",
          class: "text-black dark:text-white"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.toastInfo.title), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_ChTypography, {
          variant: "Untitled14Regular",
          class: "text-black dark:text-white mt-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.toastInfo.description), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(_component_ch_icon, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getLinks())),
              icon: "fa-brands fa-linkedin",
              iconType: "fa-light",
              class: "text-yellow cursor-pointer"
            })
          ]),
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeToast())),
            class: "cursor-pointer"
          }, _toDisplayString(_ctx.t('home-social-sharing.omitir')), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}